module.exports = __webpack_public_path__ + "media/images/svg/logo_alt-534871c754c15cb5d81ef4f7d659d3ad.svg";